// extracted by mini-css-extract-plugin
module.exports = {"RichText":"RichText_RichText__rSX17"};